import React from 'react';
import Conditional from './Conditional';
import DisplayComment from './DisplayComment';
import { Button } from 'bloomer/lib/elements/Button';

interface PropTypes {
  comments: Comment[];
  isLoading: boolean;
  noMoreComments: boolean;
  handleLoadMore?: () => void;
}

const CommentList = ({
  comments,
  isLoading,
  handleLoadMore,
  noMoreComments,
}: PropTypes) => {
  const sortedComments = comments.sort((a, b) => {
    const dateA = new Date(a.timeReturned);
    const dateB = new Date(b.timeReturned);
    return dateB.valueOf() - dateA.valueOf();
  });

  return (
    <Conditional
      check={sortedComments.length > 0}
      alt={<p>No Comments Found.</p>}
    >
      <>
        {sortedComments.map(comment => (
          <DisplayComment key={comment._id} data={comment} />
        ))}
        <Conditional check={!noMoreComments}>
          <Button isLoading={isLoading} onClick={handleLoadMore}>
            Load More
          </Button>
        </Conditional>
      </>
    </Conditional>
  );
};

export default CommentList;
